import React, { useContext } from 'react'
import { Security } from 'src/shared/security.dto'

interface SecurityContext {
  security: Security
}

const SecurityContext = React.createContext<SecurityContext>({} as any)

interface Props {
  data: SecurityContext
}

export const SecurityProvider: React.FC<Props> = ({ children, data }) => {
  return (
    <SecurityContext.Provider value={data}>{children}</SecurityContext.Provider>
  )
}

export const useSecurityContext = () => useContext(SecurityContext)
